// about-server-comment-reply.js
;(({ $, $$, log, scrollTo }) => {
    const hiddenClass = 'form-feedback--hidden-el'

    const replyBlock = $('#leave-feedback')

    // log('replyBlock', replyBlock)

    if (!replyBlock) {
        return
    }

    const feedbackForm = replyBlock.querySelector('.form-feedback')

    // log('feedbackForm', feedbackForm)

    let ratingEl = null
    let targetEl = null
    let targetNameEl = null
    let targetCancel = null
    let commentParentID = null

    if (feedbackForm) {
        ratingEl = feedbackForm.querySelector('.form-feedback__rating')
        targetEl = feedbackForm.querySelector('.form-feedback__target')
        targetNameEl = feedbackForm.querySelector('.feedback-target__target-name')
        targetCancel = feedbackForm.querySelector('.feedback-target__cancel')
        commentParentID = feedbackForm.querySelector('#comment_parent_id')


        if (!ratingEl || !targetEl || !targetNameEl || !targetCancel || !commentParentID) {
            return
        }

        // log(ratingEl, targetEl, targetNameEl, targetCancel, commentParentID)
    }

    $$('.js-comment-reply-button').forEach(replyButton => {
        replyButton.addEventListener('click', () => {
            const commentId = replyButton.dataset.commentId

            if (!commentId) {
                return
            }

            // Scroll to form
            window.scrollTo({
                top: replyBlock.offsetTop,
                behavior: "smooth"
            });

            if (!ratingEl || !targetEl || !targetNameEl || !commentParentID) {
                return
            }

            // Swap rating for target
            ratingEl.classList.add(hiddenClass)
            targetEl.classList.remove(hiddenClass)

            // Set parrent comment id
            commentParentID.value = commentId

            // Fetch target name
            const targetComment = replyButton.closest('.comment')
            const targetName = targetComment?.querySelector('.comment__author')

            // Set target name
            targetNameEl.innerText = targetName?.innerText
        })
    })

    if (targetCancel) {
        targetCancel.addEventListener('click', () => {
            targetNameEl.innerText = ''
            commentParentID.value = ''
            ratingEl.classList.remove(hiddenClass)
            targetEl.classList.add(hiddenClass)
        })
    }
})(CNS);
